import React, { useState } from "react";
import { addRemarks } from "../../store/slices/telecallerLeadSlice";
import { RootDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { IRemark } from "../../models/LeadData.model";
import toast from "react-hot-toast";

interface RemarksProps {
  remarks: IRemark[];
  // currentLead: {
  //   _id: string;
  // };
  leadId: string;
  isTelecallerContext?: boolean;
  setRemarkText: (text: string) => void;
  remarkText: string;
  setNotPickedUp: (value: boolean) => void;
  notPickedUp: boolean;
  setNotInterested: (value: boolean) => void;
  notInterested: boolean;
  setSkipped: (value: boolean) => void;
  skipped: boolean;
  agreedToMeet: boolean | null;
  setAgreedToMeet: (value: boolean | null) => void;
  showToBDE: boolean | null;
  setShowToBDE: (value: boolean | null) => void;
}

export const Remarks: React.FC<RemarksProps> = ({
  remarks,
  // currentLead,
  leadId,
  setRemarkText,
  remarkText,
  setNotPickedUp,
  notPickedUp,
  setNotInterested,
  notInterested,
  setSkipped,
  skipped,
  agreedToMeet,
  setAgreedToMeet,
  showToBDE,
  setShowToBDE,
  isTelecallerContext = false,
}) => {
  const dispatch: RootDispatch = useDispatch();
  const [followUp, setFollowUp] = useState(false);

  const role = useSelector((state: RootState) => state.auth.role);

  const handleAddRemark = async () => {
    if (!notPickedUp && remarkText.trim() === "") {
      toast.error("Please enter a remark");
      return;
    }

    let finalText = notPickedUp ? "not picked up" : remarkText.trim();

    await dispatch(
      addRemarks({ leadId, text: finalText, setFollowUp: followUp })
    );
    setRemarkText("");
    setNotPickedUp(false);
    setNotInterested(false);
    setSkipped(false);
    setShowToBDE(null);
    setFollowUp(false);
  };

  return (
    <div className="col-span-3 md:col-span-2 w-full">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-lg h-full flex flex-col">
        <div className="p-4 border-b border-gray-200 flex-shrink-0">
          <h2 className="text-base md:text-lg font-bold text-gray-800 flex items-center gap-2">
            <div className="p-2 bg-blue-100 rounded-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-blue-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            Lead Remarks
          </h2>
        </div>

        <div className="p-4 flex-1 overflow-y-auto max-h-[calc(100vh-200px)]">
          <div className="space-y-3 mb-4">
            {remarks.length > 0 &&
              remarks?.map((remark, i) => (
                <div
                  key={i}
                  className="p-3 bg-gray-50 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200"
                >
                  <div className="flex justify-between items-start gap-2">
                    <span className="text-xs font-semibold text-gray-700 capitalize">
                      {remark.username}
                    </span>
                    <div className="text-xs text-gray-500 text-right min-w-fit">
                      <div>
                        {new Date(remark.createdAt).toLocaleDateString()}
                      </div>
                      <div>
                        {new Date(remark.createdAt).toLocaleTimeString()}
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-gray-700 whitespace-pre-line">
                    {remark.text}
                  </p>
                  {remark.lastCallDateBde && (
                    <div className="mt-2 flex items-center gap-2 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded-lg w-fit">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-3.5 w-3.5 text-blue-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 5a2 2 0 012-2h2.28a2 2 0 011.94 1.46l.65 2.6a2 2 0 01-.45 1.88l-1.2 1.2a16 16 0 006.36 6.36l1.2-1.2a2 2 0 011.88-.45l2.6.65A2 2 0 0121 18.72V21a2 2 0 01-2 2h-1C9.82 23 1 14.18 1 3V2a2 2 0 012-2h2z"
                        />
                      </svg>
                      <span className="font-medium">Follow-Up Call Done</span>
                    </div>
                  )}
                </div>
              ))}
            {remarks?.length === 0 && (
              <div className="text-center py-6 text-gray-400">
                <svg
                  className="mx-auto h-10 w-10 mb-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
                <p className="font-medium text-sm">No remarks yet</p>
                <p className="text-xs">Add your first note</p>
              </div>
            )}
          </div>
        </div>

        <div className="p-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl flex-shrink-0">
          {(!notPickedUp || !isTelecallerContext) && (
            <div className="mb-4">
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="text"
                  className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent transition-all duration-200"
                  placeholder="Add a remark..."
                  value={remarkText}
                  onChange={(e) => setRemarkText(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleAddRemark()}
                />
                <button
                  onClick={handleAddRemark}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center justify-center transition-all duration-200"
                >
                  <svg
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                </button>
              </div>
              {role === "bde" && (
                <label className="flex items-center mt-2 p-2 bg-white rounded-lg border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors">
                  <input
                    type="checkbox"
                    checked={followUp}
                    onChange={(e) => setFollowUp(e.target.checked)}
                    className="form-checkbox h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                  />
                  <span className="ml-2 text-xs font-medium text-gray-700">
                    Schedule follow-up call (sets current date)
                  </span>
                </label>
              )}
            </div>
          )}

          {isTelecallerContext && (
            <div className="space-y-3">
              <div className="space-y-2">
                {!notPickedUp && (
                  <label className="flex items-center p-2 bg-white rounded-lg border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors">
                    <input
                      type="checkbox"
                      checked={skipped}
                      onChange={(e) => setSkipped(e.target.checked)}
                      className="form-checkbox h-4 w-4 text-yellow-600 rounded border-gray-300 focus:ring-yellow-500"
                    />
                    <span className="ml-2 text-xs font-medium text-gray-700">
                      Mark as skipped
                    </span>
                  </label>
                )}

                <label className="flex items-center p-2 bg-white rounded-lg border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors">
                  <input
                    type="checkbox"
                    checked={notInterested}
                    onChange={(e) => setNotInterested(e.target.checked)}
                    className="form-checkbox h-4 w-4 text-gray-600 rounded border-gray-300 focus:ring-gray-500"
                  />
                  <span className="ml-2 text-xs font-medium text-gray-700">
                    Not interested
                  </span>
                </label>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-3">
                <div className="mb-2">
                  <span className="text-xs font-semibold text-gray-700">
                    Agreed to meet?
                  </span>
                </div>
                <div className="flex gap-3 flex-wrap">
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      name="agreedToMeet"
                      value="yes"
                      checked={agreedToMeet === true}
                      onChange={() => setAgreedToMeet(true)}
                      className="form-radio h-3 w-3 text-green-600 border-gray-300 focus:ring-green-500"
                    />
                    <span className="ml-2 text-xs text-gray-700">Yes</span>
                  </label>
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      name="agreedToMeet"
                      value="no"
                      checked={agreedToMeet === false}
                      onChange={() => setAgreedToMeet(false)}
                      className="form-radio h-3 w-3 text-red-600 border-gray-300 focus:ring-red-500"
                    />
                    <span className="ml-2 text-xs text-gray-700">No</span>
                  </label>
                </div>
              </div>

              {agreedToMeet !== true && (
                <div className="bg-white rounded-lg border border-gray-200 p-3">
                  <div className="mb-2">
                    <span className="text-xs font-semibold text-gray-700">
                      Show to BDE?
                    </span>
                  </div>
                  <div className="flex gap-3 flex-wrap">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="showToBDE"
                        value="yes"
                        checked={showToBDE === true}
                        onChange={() => setShowToBDE(true)}
                        className="form-radio h-3 w-3 text-blue-600 border-gray-300 focus:ring-blue-500"
                      />
                      <span className="ml-2 text-xs text-gray-700">Yes</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="showToBDE"
                        value="no"
                        checked={showToBDE === false}
                        onChange={() => setShowToBDE(false)}
                        className="form-radio h-3 w-3 text-red-600 border-gray-300 focus:ring-red-500"
                      />
                      <span className="ml-2 text-xs text-gray-700">No</span>
                    </label>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Remarks;
